import React from "react";

const Footer = () => {
  return (
    <div>
      <footer className="footer">
        <p>
          Made by Harsha Vardhan <span>🙂</span>
        </p>
      </footer>
    </div>
  );
};
export default Footer;
